import { RootState } from '../rootReducer'
import { AccidentType as ClaimType } from '../../lib/interfaces/AccidentType.interface'

const get = require('lodash/get')
const find = require('lodash/find')

export const getClaimTypes = (state: RootState): ClaimType[] | undefined => get(state, 'accidents.accidentTypes')

export const getClaimTypeById = (state: RootState) => (claimTypeId: number) => {
  const claimTypes = getClaimTypes(state)
  return find(claimTypes, { id: claimTypeId })
}



// WEBPACK FOOTER //
// ./src/store/accidents/selectors.ts